import { profileHasBeenLoaded } from './utils/event-dispatchers';

function fetchProfile() {
    fetch('/webservices_sw/personalization/environment/').then(res => {
        res.json().then(handleProfile);
    });
}

function handleProfile({ data }) {
    if (data && Object.keys(data).length === 0) {
        setTimeout(fetchProfile, 5000);
    } else {
        profileHasBeenLoaded(data);
    }
}

document.addEventListener('DOMContentLoaded', fetchProfile);
// if (document.readyState == 'loading') {
//     document.addEventListener('load', fetchProfile);
// } else {
//     fetchProfile();
// }
